import { BaseKeyframeTween } from "./base-tween";
import RenderManager from "../../rendering/render-manager";
import calcFov from "../../utils/calc-fov";
import getRenderData from "../../helpers/get-renderdata";
import getInnerSize from "../../utils/get-inner-size";
import getLetterbox from "../../helpers/get-letterbox";

// ----------------------------------------
//                  PROJECTION
// ----------------------------------------
class TweenProjection {
    /**
     * 
     * @param {KeyframeTweenTransform} state 
     * @param {KeyframeTweenTransform} target 
     */
    constructor(state, target) {
        const { innerWidth, innerHeight } = getInnerSize();
        const letterbox = Q3.editMode ? null : getLetterbox(innerWidth, innerHeight);
        const { height: canvasHeight } = RenderManager.getSize();
        const rData = getRenderData(Q3.mobileView);
        const fullHeight = Math.round(letterbox ? letterbox.h : canvasHeight);
        const height = Math.round(fullHeight * rData.height);

        this.near = target.near;
        this.far = target.far;
        this.fov = calcFov(target.fov, canvasHeight / height);

        this.onStart = () => { };

        this.onUpdate = () => {
            RenderManager.activeCamera.near = state.near;
            RenderManager.activeCamera.far = state.far;
            RenderManager.activeCamera.fov = state.fov;

            RenderManager.activeCamera.updateProjectionMatrix();

            RenderManager.activeCamera.update = true;
        };

        this.onComplete = () => { };
    }
}

class KeyframeTweenProjection extends BaseKeyframeTween {
    constructor({ near = NaN, far = NaN, fov = NaN } = {}) {
        super();

        this.near = near;
        this.far = far;
        this.fov = fov;
    }

    /**
     * 
     * @param {SlideSettings} slide 
     */
    fromSlide(slide) {

        this.near = slide.near;
        this.far = slide.far;
        this.fov = slide.fov;

        return this;
    }

    /**
     * 
     * @param {KeyframeTweenProjection} target 
     * @param {number} time 
     */
    tweenTo(target, time) {
        const tween = new TweenProjection(this, target);

        return new TweenMax(this, time, tween);
    }
}

export { TweenProjection, KeyframeTweenProjection };